import React, { useState } from "react";
import { useForm } from "react-hook-form";
import useAuth from "../../hooks/useAuth";

import { injectStyle } from "react-toastify/dist/inject-style";
import { ToastContainer, toast } from "react-toastify";

import ReactStars from "react-rating-stars-component";

if (typeof window !== "undefined") {
  injectStyle();
}

const AddReview = () => {
  function notify() {
    toast.dark("Review submitted!");
  }

  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  //   const history = useHistory();
  //   const redirect_uri = "/";

  const ratingChanged = (newRating) => {
    console.log(newRating);
    setRating(newRating);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { user } = useAuth();

  const onSubmit = (data) => {
    data.name = user?.displayName;
    data.email = user?.email;
    data.rating = rating;
    console.log(data);
    fetch("https://young-hamlet-12954.herokuapp.com/reviews", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        setReview("");
      });
  };

  return (
    <div className="container text-center mt-2 pt-3 pb-3 m-auto add-new products">
      <h1 className="text-center fw-bold">Add Review</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input
          defaultValue={user.displayName}
          {...register("name")}
          className="form-control"
          disabled
        />
        <br />
        <input
          defaultValue={user.email}
          {...register("email")}
          className="form-control"
          disabled
        />
        {errors.email && <span className="error">This field is required</span>}
        <br />
        <textarea
          {...register("review")}
          className="form-control"
          placeholder="Add your review here"
        />
        <br />

        <h6 className="text-start fw-bold">Rating</h6>
        <ReactStars
          count={5}
          onChange={ratingChanged}
          size={24}
          isHalf={true}
          emptyIcon={<i className="far fa-star"></i>}
          halfIcon={<i className="fa fa-star-half-alt"></i>}
          filledIcon={<i className="fa fa-star"></i>}
          activeColor="#ffd700"
        />

        <br />
        <button
          className="btn btn-custom w-100"
          type="submit"
          onClick={notify}
          id="animate.css"
        >
          Submit Review
        </button>
      </form>
      <ToastContainer />
    </div>
  );
};

export default AddReview;
